import React from 'react';

import Header from '../partials/Header';
import HeroCiliaris from '../partials/HeroCiliaris';
import CiliarisComponent from '../partials/CiliarisComponent';
import Cta from '../partials/Cta';
import Footer from '../partials/Footer';

function Ciliaris() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="grow">

        {/*  Page sections */}
        <HeroCiliaris />
        <CiliarisComponent />
        <Cta/>

      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default Ciliaris;